// clases
import { Cliente } from '../modelos/cliente';

// enumeradores
import { Periodicidad } from 'src/app/catalagos/entidades/periodicidad';
import { Plazo } from 'src/app/catalagos/entidades/plazo';
import { Producto } from 'src/app/catalagos/entidades/producto';
import { TasaInteres } from 'src/app/catalagos/entidades/tasa-interes';
import { GastoAdministrativo } from 'src/app/catalagos/entidades/gasto-administrativo';
import { ComisionApertura } from 'src/app/catalagos/entidades/comision-apertura';
import { Pagare } from './pagare';
import { Persona } from 'src/app/shared/model/persona/persona';
import { Amortizacion } from './amortizacion';
import { Cotizacion } from './cotizacion';
import { Identificacion } from 'src/app/shared/model/catalogos/tipo-identificacion';
import { EstatusCredito } from './estatus-credito';
import { Usuario } from 'src/app/shared/model/security/usuario.model';
import { PagareAmortizacion } from './pagare-amortizacion';
import { NotasCredito } from './credito-notas';
import { PersonaCredito } from './persona-credito';
import { Sucursal } from 'src/app/shared/model/general/sucursal.model';
import { Base } from 'src/app/shared/model/core/base.model';
import { Poblacion } from 'src/app/catalagos/entidades/poblacion';
import { AplicacionPagoDto } from './aplicacion-pago-dto';

export class Credito extends Base{
    id: number;

    producto: Producto;
    plazo: Plazo;
    periodicidad: Periodicidad;
    interes: TasaInteres;
    gastoAdministrativo: GastoAdministrativo;
    comisionApertura: ComisionApertura;

    cliente: Persona;
    asesor: Usuario;
    analista: Usuario;
    gestor:Usuario;
    usuarioApertura:Usuario;
    codeudores: Persona[];
    coacreditados: Persona[];
    avales: Persona[];
    tipoIdentificacion: Identificacion[];
    montoSolicitado: number;
    montoAutorizado: number;
    montoEntregado: number;
    montoGastoAdministrativos: number;
    montoComisionApertura: number;
    importePago: number;
    saldoCapital: number;
    saldoInteres: number;
    saldoTotal: number;
    saldoInteresesPeriodo: number = 0;
    interesTotal:number;
    
    tasaInteresMoratorio: number;
    ivaComisionApertura: number;
    ivaGastoAdministrativo: number;
    ivaInteres: number;
    ivaTotal:number;

    fechaSolicitud: Date;
    fechaDictamen: Date;
    fechaApertura: Date;
    fechaFinProgramada: Date;
    fechaDeposito: Date;
    fechaSiguientePago: Date;
    fechaUltimoPago: Date;
    fechaUltimoEstadoCuenta: Date;

    comentarioDictamen: string;

    folio: number;
    nombreProducto: string;
    plazoCantidad: number;
    periodicidadDescripcion: string;

    porcentajeInteres: number;
    porcentajeGastoAdministrativo: number;
    porcentajeComisionApertura: number;
    estatus: EstatusCredito;
    pagares: Pagare[];
    amortizacion: Amortizacion[];
    saldoActual: number;
    saldoLiquidar: number;
    cotizacion: Cotizacion;
    referencia_bancaria: string;
    totalPagar:number;
    cantidadPagos: number;
    gastos_admi_financiado: number;
    comision_financiada: number;
    saldoParaLiquidar: number;
    saldoInteresesMoratorios: number;
    pagareVigente: PagareAmortizacion;
    pagareSiguiente: PagareAmortizacion;
    isRecalCuloPagares: boolean;

    nombreSucursal: string;
    numeroPagoActual: number;
    ultimoPagoActual: number;
    notaCredito: NotasCredito;

    numeroPagaresCubiertos: number;
	numeroPagaresVencidos: number;
	numeroPagareSiguiente: number;
	fechaVencePagareSiguiente: string;
    saldoVencido: number;
    fechaPrimerPagareNS: string;
    porcentajeRecuperado: number;
    porcentajeVencido: number;
    diasAtraso: number;
    ivaMora: number;

    montoTotalColocado: number;
    creditosColocados: number;
    totalPagoPagares: number;

    seguroVidaGastAdminVigente: number;
    seguroVidaGastAdminVencida: number;
    saldoComisionReestructura: number;
    comisionReestructuraVigente: number;
    comisionReestructuraVencida: number;
    pagoDelPeriodo: number;
    montoOriginalDelPago: number;
    esGastoComisionAperFin: number;
    sucursal:Sucursal;
    poblacion:Poblacion;

    clientes: PersonaCredito[] = [];
    selection:boolean;

    listaAplicacion: AplicacionPagoDto[] = [];
    montoPago:number = 0;

}
